// extracted by mini-css-extract-plugin
export default {"file-uploader-container":"uploader_file-uploader-container__7RxUI"};